<template>
  <div>
    <Progress />
    <h1 class="text-center mt-10 mb-2">{{ $t('pageServices.header') }}</h1>
    <v-container v-if="user.errors.departments">
      <p class="text-center">{{ user.errors.departments }}</p>
    </v-container>
    <v-container v-else>
      <p v-if="this.user.lists.departments.output.length > 1" class="text-center mt-5">{{ $t('pageServices.subHeader1') }}</p>
      <ListDepartments />
      <div v-if="this.user.department.departmentid !== undefined">
        <v-divider></v-divider>
        <h3 class="text-center mt-5 mb-4">{{ $t('pageServices.subHeader2') }}</h3>
      </div>
      <ListServices />
      <Loader v-if="this.user.loading" />
    </v-container>
    <v-container>
      <v-row no-gutters>
        <div class="col-6">
          <ProgressButton
            :label="{ text: this.text.buttonBack, alias: 'Service-button--back', page: 'services', action: 'previous' }"
            :step="{ number: -1 }"
          />
        </div>
        <div class="col-6">
          <div class="float-right">
            <ProgressButton
              :label="{ text: this.text.buttonNext, alias: 'Service-button--next', page: 'services', action: 'next' }"
              :step="{ number: 1 }"
            />
          </div>
        </div>
      </v-row>
    </v-container>
  </div>
</template>
<script>
import localizationTexts from '@/localization/texts.json';
import Progress from '@/components/Progress.vue';
import ListDepartments from '@/components/ListDepartments.vue';
import ListServices from '@/components/ListServices.vue';
import Loader from '@/components/Loader.vue';
import ProgressButton from '@/components/ProgressButton.vue';
import helpers from '@/settings/helpers';
import Vue from 'vue';
import { createNamespacedHelpers } from 'vuex';
const { mapGetters } = createNamespacedHelpers('user');

export default Vue.extend({
  name: 'Service',
  components: {
    Progress,
    ListDepartments,
    ListServices,
    Loader,
    ProgressButton
  },
  beforeMount() {
    if (this.user.kilometers > 0 && this.user.registrationplate !== '') {
      this.$store.dispatch('user/initStep', 1);
    } else if (this.user.step === 0) {
      this.$router.push({ name: 'Home' });
    }
    this.$store.dispatch('user/optionsDatesMappingsClear');
    this.$store.dispatch('user/initListDatesClear');
  },
  mounted() {
    helpers.sendScroll(this.user.config.container, 0, this.user.config.host);
    if (this.user.lists.departments.output.length === 0) {
      this.$store.dispatch('user/initLoading', true);
    } else {
      this.$store.dispatch('user/initLoading', false);
    }
    this.text.buttonBack = localizationTexts[this.user.config.language].button.back;
    this.text.buttonNext = localizationTexts[this.user.config.language].button.next;
  },
  updated() {
    if (this.user.lists.departments.output.length === 0 && !this.user.loading) {
      this.$store.dispatch('user/initLoading', true);
    } else if (this.user.lists.departments.output.length > 0 && this.user.loading) {
      this.$store.dispatch('user/initLoading', false);
    }
  },
  data() {
    return {
      text: {
        buttonBack: '',
        buttonNext: ''
      }
    };
  },
  computed: {
    ...mapGetters(['user'])
  }
});
</script>

<style scoped lang="scss"></style>

<i18n src="../localization/texts.json"></i18n>
